import { Controller } from '@hotwired/stimulus';
import TooltipController from './tooltip-controller';

export default class extends Controller {
  static readonly targets = ['input', 'decrement', 'increment'];
  static readonly outlets = ['tooltip'];

  declare inputTarget: HTMLInputElement;
  declare decrementTarget: HTMLButtonElement;
  declare incrementTarget: HTMLButtonElement;

  declare tooltipOutlet: TooltipController;
  declare hasTooltipOutlet: boolean;

  private quantity = 0;
  private min = 0;
  private max = 0;

  connect() {
    this.initializeValues();
    this.updateState();
    this.inputTarget.addEventListener('input', this.onInput);
  }

  private initializeValues() {
    this.quantity = Number.parseInt(this.inputTarget.value, 10) || 0;
    this.min = Number.parseInt(this.inputTarget.min, 10) || 0;
    this.max = Number.parseInt(this.inputTarget.max, 10) || 0;
  }

  private updateState() {
    this.quantity = Number.parseInt(this.inputTarget.value, 10);

    this.quantity = Math.min(this.quantity, this.max);
    this.quantity = Math.max(this.quantity, this.min);

    this.decrementTarget.disabled = this.quantity <= this.min;
    this.incrementTarget.disabled = this.quantity >= this.max;

    if (this.incrementTarget.disabled) {
      this.tooltipOutlet.enable();
    } else {
      this.tooltipOutlet.disable();
      this.tooltipOutlet.hide();
    }
  }

  private onInput = () => {
    this.updateState();
    this.inputTarget.value = this.quantity.toString();
  };

  updateQuantity() {
    this.updateState();
  }

  decrementQuantity() {
    this.inputTarget.stepDown();
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }));
  }

  incrementQuantity() {
    this.inputTarget.stepUp();
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
